module.exports = __webpack_public_path__ + "static/images/jxcj1.0458775cf.png";